import { render } from "./RowCategoriesContainer.vue?vue&type=template&id=aa24da6c&scoped=true"
import script from "./RowCategoriesContainer.vue?vue&type=script&lang=js"
export * from "./RowCategoriesContainer.vue?vue&type=script&lang=js"

import "./RowCategoriesContainer.vue?vue&type=style&index=0&id=aa24da6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa24da6c"]])

export default __exports__